import React from 'react';
var isSub = function isSub(type) {
  return type === 'sub';
};
export default function SubSup(props) {
  if (isSub(props.type)) {
    return /*#__PURE__*/React.createElement("sub", props.dataAttributes, props.children);
  }
  return /*#__PURE__*/React.createElement("sup", props.dataAttributes, props.children);
}